import { render, staticRenderFns } from "./userSetIndex.vue?vue&type=template&id=21b44896"
import script from "./userSetIndex.vue?vue&type=script&lang=js"
export * from "./userSetIndex.vue?vue&type=script&lang=js"
import style0 from "./userSetIndex.vue?vue&type=style&index=0&id=21b44896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports